import { RefObject, useCallback, useRef } from 'react'

import { viewDroppeAdEvent } from '../../../utils/analytics/droppeAdEvents'
import useIntersectionObserver from '../../hooks/useIntersectionObserver'
import { StrapiDroppeAdCampaignAttribute, StrapiMediaAttributeDataSingle } from '../../../utils/types/strapi'

interface UseViewAdBannerEventParams {
  adBannerData?: StrapiDroppeAdCampaignAttribute
  imageObject?: StrapiMediaAttributeDataSingle
}

const useViewAdBannerEvent = <T extends HTMLElement = HTMLDivElement>(
  params: UseViewAdBannerEventParams,
): RefObject<T> => {
  const { adBannerData, imageObject } = params
  const bannerRef = useRef<T>(null)

  const viewAdBannerEventCallback = useCallback(() => {
    if (adBannerData && imageObject) {
      viewDroppeAdEvent({
        adLocation: 'category_sidebar',
        adCampaign: adBannerData.campaignName || '',
        adName: adBannerData.bannerCategoryPage?.[0]?.adName || '',
        adVariant: imageObject.data?.attributes?.name || '',
      })
    }
  }, [adBannerData, imageObject])

  // Trigger analytics event only when 60% or more of the banner is visible
  useIntersectionObserver(
    bannerRef,
    viewAdBannerEventCallback,
    { onlyFireOnce: true, threshold: 0.6 },
    [imageObject],
  )

  return bannerRef
}

export default useViewAdBannerEvent
